import { AudioDeviceInfo, VideoDeviceInfo } from "@azure/communication-calling";

export type NullableVideoDevice = VideoDeviceInfo | null | undefined;
export type NullableAudioDevice = AudioDeviceInfo | null | undefined;

export type NullableVideoDeviceList = VideoDeviceInfo[] | null | undefined;
export type NullableAudioDeviceList = AudioDeviceInfo[] | null | undefined;

// State of application
export enum DeviceTesterTestState {
  CAMERA = 0,
  AUDIO = 1,
  RESULTS = 2,
  COMPLETE = 3,
}

// State of Audio testing feature
export enum AudioTestState {
  INITIATED = 0,
  STARTED = 1,
  CONNECTING = 2,
  CONNECTED = 3,
  DISCONNECTED = 4,
  RESULT_CLARITY = 5,
  RESULT_FINISH_PROMPT = 6,
  TEST_UNCLEAR = 7,
}

// State of Audio testing feature
export enum ResultsViewState {
  INITIAL = 0,
  SELECT_SPEAKER = 1,
}

// State of Audio testing feature
export enum ErrorPages {
  BrowserNotSupported = "BROWSER_NOT_SUPPORTED",
  SessionTimeout = "SESSION_TIMEOUT",
  AcsCallError = "ACS_CALL_ERROR",
}

export enum Devices {
  Camera = "Camera",
  Network = "Network",
  Mic = "Mic",
  Speaker = "Speaker",
}

export enum DeviceStatusDialogState {
  OPEN_NETWORK_DIALOG = "OPEN_NETWORK_DIALOG",
  OPEN_CAM_DIALOG = "OPEN_CAMERA_DIALOG",
  OPEN_MIC_DIALOG = "OPEN_MIC_DIALOG",
  OPEN_SPEAKER_DIALOG = "OPEN_SPEAKER_DIALOG",
  CLOSED = "CLOSED",
}

export type DropDownInput = {
  key: string;
  header: string;
};

// Device Information returned via ACS SDK
export type DeviceInfo = {
  microphones: NullableAudioDeviceList;
  speakers: NullableAudioDeviceList;
  cameras: NullableVideoDeviceList;
  defaultMicrophone: NullableAudioDevice;
  defaultSpeaker: NullableAudioDevice;
  defaultCamera: NullableVideoDevice;
  micAccess: boolean;
  cameraAccess: boolean;
  isSpeakerSelectionAvailable: boolean;
  isAcsTokenFetched: boolean;
};

export type DeviceSettings = {
  // Available devices list
  microphones: NullableAudioDeviceList;
  speakers: NullableAudioDeviceList;
  cameras: NullableVideoDeviceList;
  // Currently selected devices to test
  selectedMicrophone: NullableAudioDevice;
  selectedSpeaker: NullableAudioDevice;
  selectedCamera: NullableVideoDevice;
  // Flag to check whether camera stream is enabled or disabled;
  isCamOn: boolean;

  //Audio Video Access Permissions
  cameraAccess: boolean;
  micAccess: boolean;
};

export type DeviceErrorProps = {
  message: string;
};

export type DeviceAccess = {
  cameraAccess: boolean;
  micAccess: boolean;
};

export type AudioDevices = {
  microphones: NullableAudioDeviceList;
  speakers: NullableAudioDeviceList;
};

export type CameraDevices = {
  cameras: NullableVideoDeviceList;
};
